'use client';

import { c as _c } from "react/compiler-runtime";
import { LightCard } from '@algoacademy/design-system/web/data-display/Card';
import { CalendarWrapper } from '@algoacademy/design-system/web/forms/Calendar';
import { P3 } from '@algoacademy/design-system/web/typography/Paragraph';
import { format, isBefore } from 'date-fns';
import { useState } from 'react';
import { useMediaQuery } from 'usehooks-ts';
import { useSeedSelectedEventsMapWithEventsAvailableForBooking } from '@/app/(marketing-site)/_hooks/useSeedSelectedEventsMapWithEventsAvailableForBooking';
import { type CalendarEvent, Event } from '@/app/(marketing-site)/bezplatna-konsultacja/_components/CalendarEvent';
type BookPhoneCallProps = {
  selectedDay: Date;
  onSelectedDayChange: React.Dispatch<React.SetStateAction<Date>>;
  selectedEvent: CalendarEvent | null;
  onSelectedEventChange: React.Dispatch<React.SetStateAction<CalendarEvent | null>>;
  eventsRef: React.RefObject<HTMLDivElement | null>;
  formRef: React.RefObject<HTMLDivElement | null>;
};
export function Calendar(t0) {
  const $ = _c(29);
  const {
    selectedDay,
    onSelectedDayChange,
    selectedEvent,
    onSelectedEventChange,
    eventsRef,
    formRef
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Map();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [availableForBookingEventsMap, setAvailableForBookingEventsMap] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      setAvailableForBookingEventsMap
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  useSeedSelectedEventsMapWithEventsAvailableForBooking(t2);
  const isDesktopView = useMediaQuery("(min-width: 768px)");
  let t3;
  if ($[2] !== eventsRef || $[3] !== isDesktopView || $[4] !== onSelectedDayChange) {
    t3 = day => {
      onSelectedDayChange(day);
      if (!isDesktopView) {
        setTimeout(() => {
          eventsRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }, 100);
      }
    };
    $[2] = eventsRef;
    $[3] = isDesktopView;
    $[4] = onSelectedDayChange;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== availableForBookingEventsMap || $[7] !== selectedDay) {
    t4 = {
      withAvailableForBookingEvents: day_0 => {
        const formattedDay = format(day_0, "yyyy.MM.dd");
        const isToday = formattedDay === format(new Date(), "yyyy.MM.dd");
        const isSelected = format(selectedDay, "yyyy.MM.dd") === formattedDay;
        return availableForBookingEventsMap.has(formattedDay) && !isToday && !isSelected && !isBefore(day_0, new Date());
      }
    };
    $[6] = availableForBookingEventsMap;
    $[7] = selectedDay;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      withAvailableForBookingEvents: "bg-backgroundBlue !text-contentNavyAlgo"
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== availableForBookingEventsMap) {
    t6 = day_1 => {
      const formattedDay_0 = format(day_1, "yyyy.MM.dd");
      return !availableForBookingEventsMap.has(formattedDay_0) || isBefore(day_1, new Date());
    };
    $[10] = availableForBookingEventsMap;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== selectedDay || $[13] !== t3 || $[14] !== t4 || $[15] !== t6) {
    t7 = <LightCard className="flex flex-row justify-center gap-4 rounded-md p-2 sm:p-6"><CalendarWrapper className="w-fit" mode="single" selected={selectedDay} onSelect={t3} required={true} modifiers={t4} modifiersClassNames={t5} disabled={t6} /></LightCard>;
    $[12] = selectedDay;
    $[13] = t3;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== availableForBookingEventsMap || $[18] !== formRef || $[19] !== onSelectedEventChange || $[20] !== selectedDay || $[21] !== selectedEvent?.id) {
    t8 = <LightCard className="h-full space-y-4 rounded-md p-4">{availableForBookingEventsMap.get(format(selectedDay, "yyyy.MM.dd"))?.length ? <section className="grid auto-rows-min grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">{availableForBookingEventsMap.get(format(selectedDay, "yyyy.MM.dd"))?.map(event => <Event key={event.id} event={event} isChecked={selectedEvent?.id === event.id} handleSelectedEvent={() => {
          onSelectedEventChange(event);
          setTimeout(() => formRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start"
          }), 100);
        }} />)}</section> : <P3>W tym dniu nie mamy żadnych dostępnych terminów</P3>}</LightCard>;
    $[17] = availableForBookingEventsMap;
    $[18] = formRef;
    $[19] = onSelectedEventChange;
    $[20] = selectedDay;
    $[21] = selectedEvent?.id;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== eventsRef || $[24] !== t8) {
    t9 = <section className="flex-1" ref={eventsRef}>{t8}</section>;
    $[23] = eventsRef;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t7 || $[27] !== t9) {
    t10 = <main className="flex flex-col gap-4"><section className="flex flex-col gap-4 md:flex-row">{t7}{t9}</section></main>;
    $[26] = t7;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
}